export const resultsData = {
  "search_metadata": {
      "id": "6267890695bf9228b14f8f79",
      "status": "Success",
      "json_endpoint": "https://serpapi.com/searches/6cb0b574bbd0be0a/6267890695bf9228b14f8f79.json",
      "created_at": "2022-04-26 05:54:14 UTC",
      "processed_at": "2022-04-26 05:54:14 UTC",
      "google_url": "https://www.google.com/search?q=Coffee&oq=Coffee&sourceid=chrome&ie=UTF-8",
      "raw_html_file": "https://serpapi.com/searches/6cb0b574bbd0be0a/6267890695bf9228b14f8f79.html",
      "total_time_taken": 3.05
  },
  "search_parameters": {
      "engine": "google",
      "q": "Coffee",
      "google_domain": "google.com",
      "device": "desktop"
  },
  "search_information": {
      "organic_results_state": "Results for exact spelling",
      "query_displayed": "Coffee",
      "total_results": 2690000000,
      "time_taken_displayed": 0.81
  },
  "recipes_results": [
      {
          "title": "Coffee recipes",
          "link": "https://www.bbcgoodfood.com/recipes/collection/coffee-recipes",
          "source": "BBC Good Food",
          "total_time": "No reviews",
          "ingredients": [
              "Instant coffee"
          ],
          "thumbnail": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXiLm26jaPgu4H9mDHJLTdr2VrQCYi0CVzeSuqTevGoUDH9eUoMxt0Ag&s=0"
      },
      {
          "title": "Whipped Coffee",
          "link": "https://cooking.nytimes.com/recipes/1021005-whipped-coffee",
          "source": "NYT Cooking - The New York Times",
          "rating": 4.0,
          "reviews": 785,
          "ingredients": [
              "Instant coffee",
              "ice",
              "milk",
              "hot water"
          ],
          "thumbnail": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlZppLOb8b8Jp9_4UD3PXNm6XHSSpr2WoVegsrhC-xBwIiw5-b5MEX0g&s=0"
      },
      {
          "title": "Dalgona Coffee (Whipped Coffee)",
          "link": "https://www.allrecipes.com/recipe/279548/dalgona-coffee-whipped-coffee/",
          "source": "Allrecipes",
          "rating": 4.5,
          "reviews": 24,
          "total_time": "5 min",
          "ingredients": [
              "Instant coffee",
              "white sugar",
              "boiling water",
              "whole milk"
          ],
          "thumbnail": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2a0kTHd8nKgbamnjluWgVjFRKrmiEMyQSG51upkdSeFEu3PtiBQb0pg&s=0"
      }
  ],
  "knowledge_graph": {
      "title": "Coffee",
      "type": "Drink",
      "header_images": [
          {
              "source": "https://en.wikipedia.org/wiki/Coffee"
          },
          {
              "source": "https://www.nbcnews.com/better/lifestyle/how-tap-health-benefits-coffee-ncna1096031"
          },
          {
              "source": "https://www.tastingtable.com/718678/coffee-brands-ranked-from-worst-to-best/"
          },
          {
              "source": "https://www.tastingtable.com/794355/different-types-of-coffee-explained/"
          }
      ],
      "description": "Coffee is a brewed drink prepared from roasted coffee beans, the seeds of berries from certain flowering plants in the Coffea genus. From the coffee fruit, the seeds are separated to produce a stable, raw product: unroasted green coffee.",
      "source": {
          "name": "Wikipedia",
          "link": "https://en.wikipedia.org/wiki/Coffee"
      },
      "patron_saint": "Saint Drogo of Sebourg redrockroasters.com",
      "patron_saint_links": [
          {
              "text": "Patron saint",
              "link": "https://www.google.com/search?q=coffee+patron+saint&stick=H4sIAAAAAAAAAOPgE-LUz9U3MCorTMvVksrPttIvzsgvKklLTC6xKkgsKcrPiy9OzMwrWcQqnJyflpaaqgARVQCLAgBzUMsxPwAAAA&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q6BMoAHoECGoQAg"
          },
          {
              "text": "redrockroasters.com",
              "link": "https://www.redrockroasters.com/shop-accessories/saint-drogo-pocket-retablo"
          }
      ],
      "starbucks_coffee": [
          {
              "name": "STARBUCKS Blend",
              "link": "https://www.google.com/search?q=STARBUCKS+Blend&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtV4tVP1zc0zLU0ycizTDHTEslOttJPzs_Nzc-zSskvzytPLEopXsVoCBTLyUlNLsnMz9PPzssvz0lNSU-NL0jMS80p1i_OyC8oyMxLj88uiE_NyUzPTMpJXcTKHxziGOQU6uwdrOCUk5qXsoOVEQAXO0EuewAAAA&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QxA16BAhnEAU",
              "serpapi_link": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=STARBUCKS+Blend&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtV4tVP1zc0zLU0ycizTDHTEslOttJPzs_Nzc-zSskvzytPLEopXsVoCBTLyUlNLsnMz9PPzssvz0lNSU-NL0jMS80p1i_OyC8oyMxLj88uiE_NyUzPTMpJXcTKHxziGOQU6uwdrOCUk5qXsoOVEQAXO0EuewAAAA",
              "image": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/4e7265fa044919cd02a1c36a4cd347bee16f0bfffccd919ac6e3ca5b3b2af12d79354cec99fd3c5c144ab489691557bc.jpeg"
          },
          {
              "name": "STARBUCKS ESPRESSO ROAST",
              "link": "https://www.google.com/search?q=STARBUCKS+ESPRESSO+ROAST&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtV4tVP1zc0LDKrMrRMtizXEslOttJPzs_Nzc-zSskvzytPLEopXsVoCBTLyUlNLsnMz9PPzssvz0lNSU-NL0jMS80p1i_OyC8oyMxLj88uiE_NyUzPTMpJXcQqERziGOQU6uwdrOAaHBDkGhzsrxDk7xgcsoOVEQB1Hm7YhAAAAA&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QxA16BAhnEAc",
              "serpapi_link": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=STARBUCKS+ESPRESSO+ROAST&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtV4tVP1zc0LDKrMrRMtizXEslOttJPzs_Nzc-zSskvzytPLEopXsVoCBTLyUlNLsnMz9PPzssvz0lNSU-NL0jMS80p1i_OyC8oyMxLj88uiE_NyUzPTMpJXcQqERziGOQU6uwdrOAaHBDkGhzsrxDk7xgcsoOVEQB1Hm7YhAAAAA",
              "image": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/4e7265fa044919cd02a1c36a4cd347bee16f0bfffccd919ac6e3ca5b3b2af12d6d58e29560aad5c35f25b43ae51480ef.png"
          },
          {
              "name": "Starbucks Roast Dark Ro...",
              "link": "https://www.google.com/search?q=Starbucks+Roast+Dark+Roast+Ground+Coffee&stick=H4sIAAAAAAAAAC3IMQrCMBQAUEQKOriIByhO4vKtLtJVwV0PUNLkJ8Yk_8ekteBxHD2Bx9PB7fEm4_kUAmy2j7sOyxkYqKqblrun27frhZM1SA6BqVY80CCSyu9R9TvvUXaWCRzx4FEZbKIg9BnylWO0ZBoXG_TW2Nbjq1hdOpHaXrpcnlnkrjyK5P48Je5JlQfWGvFTjL5shC6JlAAAAA&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QxA16BAhnEAk",
              "serpapi_link": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Starbucks+Roast+Dark+Roast+Ground+Coffee&stick=H4sIAAAAAAAAAC3IMQrCMBQAUEQKOriIByhO4vKtLtJVwV0PUNLkJ8Yk_8ekteBxHD2Bx9PB7fEm4_kUAmy2j7sOyxkYqKqblrun27frhZM1SA6BqVY80CCSyu9R9TvvUXaWCRzx4FEZbKIg9BnylWO0ZBoXG_TW2Nbjq1hdOpHaXrpcnlnkrjyK5P48Je5JlQfWGvFTjL5shC6JlAAAAA",
              "image": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/4e7265fa044919cd02a1c36a4cd347bee16f0bfffccd919ac6e3ca5b3b2af12d993792bcae8ed29a06502386ce7483a3.jpeg"
          },
          {
              "name": "Starbucks Frappuccino, Caramel...",
              "link": "https://www.google.com/search?q=Starbucks+Frappuccino,+Caramel,+13.7+Oz&stick=H4sIAAAAAAAAAA3IMQrCMBQAUIoUdHARDxBcBCmmqYLQVXB18AAlTX9jyP9JTFoLHsfRE3g8feObz1YLTrysno-eNkuuuRC6OpZEttqtraq58kTe1Z2f3CRjlz6Z-B8iqMF4x63zE0KnoQnSASae7j4E43RjQwNotGkR3vn2NsjYjsomdokyhFEp43zBzjJKAiyYOOxP7Pr65tkPqGF6KJMAAAA&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QxA16BAhnEAs",
              "serpapi_link": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Starbucks+Frappuccino%2C+Caramel%2C+13.7+Oz&stick=H4sIAAAAAAAAAA3IMQrCMBQAUIoUdHARDxBcBCmmqYLQVXB18AAlTX9jyP9JTFoLHsfRE3g8feObz1YLTrysno-eNkuuuRC6OpZEttqtraq58kTe1Z2f3CRjlz6Z-B8iqMF4x63zE0KnoQnSASae7j4E43RjQwNotGkR3vn2NsjYjsomdokyhFEp43zBzjJKAiyYOOxP7Pr65tkPqGF6KJMAAAA",
              "image": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/4e7265fa044919cd02a1c36a4cd347bee16f0bfffccd919ac6e3ca5b3b2af12db59935d7441a9a53b0224c6c3198f865.jpeg"
          }
      ],
      "starbucks_coffee_link": "https://www.google.com/search?q=Starbucks+coffee&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtVQjC1RLKTrfST83Nz8_OsUvLL88oTi1KKVzEaAsVyclKTSzLz8_Sz8_LLc1JT0lPjCxLzUnOK9Ysz8gsKMvPS47ML4lNzMtMzk3JSF7EKBJckFiWVJmcXKyTnp6Wlpu5gZQQA9PxcUngAAAA&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QMSgAegQIZxAB",
      "starbucks_coffee_stick": "H4sIAAAAAAAAAONgFuLUz9U3MCorTMtVQjC1RLKTrfST83Nz8_OsUvLL88oTi1KKVzEaAsVyclKTSzLz8_Sz8_LLc1JT0lPjCxLzUnOK9Ysz8gsKMvPS47ML4lNzMtMzk3JSF7EKBJckFiWVJmcXKyTnp6Wlpu5gZQQA9PxcUngAAAA",
      "songs_about_coffee": [
          {
              "name": "The Coffee Song",
              "link": "https://www.google.com/search?q=Frank+Sinatra+The+Coffee+Song&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtV4tVP1zc0TEmriC8yMTHUEslOttJPzs_Nzc-zSskvzytPLEopXsUoGJSanF-UkpmX7pxTWlySWlS8iFXWrSgxL1shODMvsaQoUSEkI1XBOT8tLTVVITg_L30HKyMA2VObv2kAAAA&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QxA16BAhkEAU",
              "serpapi_link": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Frank+Sinatra+The+Coffee+Song&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtV4tVP1zc0TEmriC8yMTHUEslOttJPzs_Nzc-zSskvzytPLEopXsUoGJSanF-UkpmX7pxTWlySWlS8iFXWrSgxL1shODMvsaQoUSEkI1XBOT8tLTVVITg_L30HKyMA2VObv2kAAAA",
              "image": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/4e7265fa044919cd02a1c36a4cd347bec68345b8c035073d19b7abae6dcce6c2eff6cecf1507d0f462f7f5f02d4f2757.jpeg"
          },
          {
              "name": "One More Cup Of Coffee",
              "link": "https://www.google.com/search?q=Bob+Dylan+One+More+Cup+Of+Coffee&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtV4tFP1zcsNjAtLDS1yNMSyU620k_Oz83Nz7NKyS_PK08sSilexSgYlJqcX5SSmZfunFNaXJJaVLyIVcEpP0nBpTInMU_BPy9VwTe_KFXBubRAwT9NwTk_LS01dQcrIwAvRj-AawAAAA&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QxA16BAhkEAc",
              "serpapi_link": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Bob+Dylan+One+More+Cup+Of+Coffee&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtV4tFP1zcsNjAtLDS1yNMSyU620k_Oz83Nz7NKyS_PK08sSilexSgYlJqcX5SSmZfunFNaXJJaVLyIVcEpP0nBpTInMU_BPy9VwTe_KFXBubRAwT9NwTk_LS01dQcrIwAvRj-AawAAAA",
              "image": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/4e7265fa044919cd02a1c36a4cd347bec68345b8c035073d19b7abae6dcce6c2f68c92008fcb5bd01f03322fe641dab7.jpeg"
          },
          {
              "name": "Cup of Coffee",
              "link": "https://www.google.com/search?q=Johnny+Cash+Cup+of+Coffee&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtV4tVP1zc0TDIvyMs1SjLVEslOttJPzs_Nzc-zSskvzytPLEopXsUoGJSanF-UkpmX7pxTWlySWlS8iFXSKz8jL69SwTmxOEPBubRAIT9NwTk_LS01dQcrIwD8wkq1ZQAAAA&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QxA16BAhkEAk",
              "serpapi_link": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Johnny+Cash+Cup+of+Coffee&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtV4tVP1zc0TDIvyMs1SjLVEslOttJPzs_Nzc-zSskvzytPLEopXsUoGJSanF-UkpmX7pxTWlySWlS8iFXSKz8jL69SwTmxOEPBubRAIT9NwTk_LS01dQcrIwD8wkq1ZQAAAA",
              "image": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/4e7265fa044919cd02a1c36a4cd347bec68345b8c035073d19b7abae6dcce6c2602a6de9da619cceb1e4108c9f6bf821.jpeg"
          },
          {
              "name": "One Cup of Coffee",
              "link": "https://www.google.com/search?q=Bob+Marley+and+the+Wailers+One+Cup+of+Coffee&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtV4tVP1zc0TDMys0iqMDPREslOttJPzs_Nzc-zSskvzytPLEopXsUoGJSanF-UkpmX7pxTWlySWlS8iFXHKT9JwTexKCe1UiExL0WhJCNVITwxMwcoqeCfl6rgXFqgkJ-m4JyflpaauoOVEQA8ZQtEeAAAAA&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QxA16BAhkEAs",
              "serpapi_link": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Bob+Marley+and+the+Wailers+One+Cup+of+Coffee&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtV4tVP1zc0TDMys0iqMDPREslOttJPzs_Nzc-zSskvzytPLEopXsUoGJSanF-UkpmX7pxTWlySWlS8iFXHKT9JwTexKCe1UiExL0WhJCNVITwxMwcoqeCfl6rgXFqgkJ-m4JyflpaauoOVEQA8ZQtEeAAAAA",
              "image": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/4e7265fa044919cd02a1c36a4cd347bec68345b8c035073d19b7abae6dcce6c2c9161c025264285557a6c7f70c50ffe7.jpeg"
          }
      ],
      "songs_about_coffee_link": "https://www.google.com/search?q=Songs+about+coffee&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtVQjC1RLKTrfST83Nz8_OsUvLL88oTi1KKVzEKBqUm5xelZOalO-eUFpekFhUvYhUKzs9LL1ZITMovLVFIzk9LS03dwcoIAGEdi6laAAAA&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QMSgAegQIZBAB",
      "songs_about_coffee_stick": "H4sIAAAAAAAAAONgFuLUz9U3MCorTMtVQjC1RLKTrfST83Nz8_OsUvLL88oTi1KKVzEKBqUm5xelZOalO-eUFpekFhUvYhUKzs9LL1ZITMovLVFIzk9LS03dwcoIAGEdi6laAAAA",
      "people_also_search_for": [
          {
              "name": "Tea",
              "link": "https://www.google.com/search?q=Tea&si=ANhW_NrAsNux2XRT8PWN_89z-Y9evUSuH-e-zTPDDMWEqKR-OE6eVf_p_2_-08uPOUcihTQk4wuK613H7zMNGj2wSIWtq0mgRs2j-CrKaL5HjKXQC1S9v-M928111NsA9E8uOOgLhQRMbKrSfoVOuQIve57LcRIwvVrNHmtIDShXB-RsBrVOL7NQjt1zivT9BcfZfs64L-B_EHGaThpbj4aTSHgRtklZFy_Cudt8nOj7SsQVduJZRSH9jQe0bg9dJAyBA7o5BicQAoNXBjbmNlNfFa9-MKIpVA%3D%3D&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QxA16BAhmEAU",
              "serpapi_link": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Tea&si=ANhW_NrAsNux2XRT8PWN_89z-Y9evUSuH-e-zTPDDMWEqKR-OE6eVf_p_2_-08uPOUcihTQk4wuK613H7zMNGj2wSIWtq0mgRs2j-CrKaL5HjKXQC1S9v-M928111NsA9E8uOOgLhQRMbKrSfoVOuQIve57LcRIwvVrNHmtIDShXB-RsBrVOL7NQjt1zivT9BcfZfs64L-B_EHGaThpbj4aTSHgRtklZFy_Cudt8nOj7SsQVduJZRSH9jQe0bg9dJAyBA7o5BicQAoNXBjbmNlNfFa9-MKIpVA%3D%3D",
              "image": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/4e7265fa044919cd02a1c36a4cd347be7a89df83f7ed1507eb465a40e0c637dc4102da84ecfd68e9d09724ca0525477a.jpeg"
          },
          {
              "name": "Espresso",
              "link": "https://www.google.com/search?q=Espresso&si=ANhW_NrAsNux2XRT8PWN_89z-Y9evUSuH-e-zTPDDMWEqKR-OLYeR2k9L3zf9oGPY79Xt7SC04v6g2QoJyOOZhAUBHJq0ScZzOIQP8LS7BZ67cWJUFTObHkCBnIqFYUtrjF97FVDCVmdSwe-3euFkH42LdGEFPmT1ezORr_n_l0TVKO9c7R8UbH6Vd7z8L__yNn9MxMeCnrWqLKYhclQWEkzZPNykosjv-Lthhl3xePoMSh0XEOTdd03WvCQtmwGVVrGc00RRnoaELItD53YxMJsKgzQ-ceFnrvO4aNooaj2bwar9NVW-hY%3D&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QxA16BAhmEAc",
              "serpapi_link": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Espresso&si=ANhW_NrAsNux2XRT8PWN_89z-Y9evUSuH-e-zTPDDMWEqKR-OLYeR2k9L3zf9oGPY79Xt7SC04v6g2QoJyOOZhAUBHJq0ScZzOIQP8LS7BZ67cWJUFTObHkCBnIqFYUtrjF97FVDCVmdSwe-3euFkH42LdGEFPmT1ezORr_n_l0TVKO9c7R8UbH6Vd7z8L__yNn9MxMeCnrWqLKYhclQWEkzZPNykosjv-Lthhl3xePoMSh0XEOTdd03WvCQtmwGVVrGc00RRnoaELItD53YxMJsKgzQ-ceFnrvO4aNooaj2bwar9NVW-hY%3D",
              "image": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/4e7265fa044919cd02a1c36a4cd347be7a89df83f7ed1507eb465a40e0c637dc784ee651d476125663cf01d18225bba6.jpeg"
          },
          {
              "name": "Drink",
              "link": "https://www.google.com/search?q=Beverage&si=ANhW_NqV8qI35yj8Nx6orC9ZgA9-mqoEvL1o3gu1i7LL5wSj5RVCr-5i3eJefp2mQJnTeN7HwNmMnqSD17sF5VvL6M7ujCZcXf1lLgxSWWvaAKU4ahQm2sD2s5lEEQt9DSuyzmKdsID-Uq3Kdi4I69J0mDXmFfv2tbJL7IE8REvzNZfnWem199itu5ewgf23Y7CSl50sqSMfIFlX5JiI12BNU7v6FmpJlKdvMsm6ifNxslXYQqMabB7HZbo1P7QwhkrWO5CZpkHP2kWm3FzXyJfR7GNUHgD50TeVmTNXeD0Dpg6-HgIti-0%3D&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QxA16BAhmEAk",
              "serpapi_link": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Beverage&si=ANhW_NqV8qI35yj8Nx6orC9ZgA9-mqoEvL1o3gu1i7LL5wSj5RVCr-5i3eJefp2mQJnTeN7HwNmMnqSD17sF5VvL6M7ujCZcXf1lLgxSWWvaAKU4ahQm2sD2s5lEEQt9DSuyzmKdsID-Uq3Kdi4I69J0mDXmFfv2tbJL7IE8REvzNZfnWem199itu5ewgf23Y7CSl50sqSMfIFlX5JiI12BNU7v6FmpJlKdvMsm6ifNxslXYQqMabB7HZbo1P7QwhkrWO5CZpkHP2kWm3FzXyJfR7GNUHgD50TeVmTNXeD0Dpg6-HgIti-0%3D",
              "image": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/4e7265fa044919cd02a1c36a4cd347be7a89df83f7ed1507eb465a40e0c637dcb07c36894b3ad296e5c517f6f1c03b3d.jpeg"
          },
          {
              "name": "Iced coffee",
              "link": "https://www.google.com/search?q=Iced+coffee&si=ANhW_NqMq05hm_NHatki2oB83qRn9HU6YTauVAJv82wgMbWR1RQm0qPEsu5ks9zupNycz9MPBHpSAdPXLFZHCFkHknR3Q6aRbjAUWJH7FhSUaH8wbnFuBBshj0yQCs9pwoRxNSy58fJKV7uuQAO-2uBt3Rd66QEXIlUZo-s4PaiOxmtjswCCJy89muPQzuzUFNaAvA0_quSgCZyY1Cu94RmUoXubc8GWptiIggsQUys5iQESJr6DlEDGD9jVG_4D-kA-Sg0ORiOf8YlnL-rwP_pDWRoj-9wFeW-hjqz4k2JmgqgA6PHbXHw%3D&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QxA16BAhmEAs",
              "serpapi_link": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Iced+coffee&si=ANhW_NqMq05hm_NHatki2oB83qRn9HU6YTauVAJv82wgMbWR1RQm0qPEsu5ks9zupNycz9MPBHpSAdPXLFZHCFkHknR3Q6aRbjAUWJH7FhSUaH8wbnFuBBshj0yQCs9pwoRxNSy58fJKV7uuQAO-2uBt3Rd66QEXIlUZo-s4PaiOxmtjswCCJy89muPQzuzUFNaAvA0_quSgCZyY1Cu94RmUoXubc8GWptiIggsQUys5iQESJr6DlEDGD9jVG_4D-kA-Sg0ORiOf8YlnL-rwP_pDWRoj-9wFeW-hjqz4k2JmgqgA6PHbXHw%3D",
              "image": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/4e7265fa044919cd02a1c36a4cd347be7a89df83f7ed1507eb465a40e0c637dc7b16beacce0afe7dcf78c3280dc3bca3.jpeg"
          }
      ],
      "people_also_search_for_link": "https://www.google.com/search?q=Coffee&stick=H4sIAAAAAAAAAONgFuLUz9U3MCorTMtVQjC1BIMzU1LLEyuL_VIrSoJLUguKF7GyOeenpaWm7mBlBABkIv_mNwAAAA&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8QMSgAegQIZhAB",
      "people_also_search_for_stick": "H4sIAAAAAAAAAONgFuLUz9U3MCorTMtVQjC1BIMzU1LLEyuL_VIrSoJLUguKF7GyOeenpaWm7mBlBABkIv_mNwAAAA",
      "see_results_about": [
          {
              "name": "Coffee bean",
              "extensions": [
                  "A coffee bean is a seed of the Coffea plant and the source for ..."
              ],
              "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsUAQMybjbOm6kuiTi8NWDJibPy1GuI5_DFn75xWj6gMgDml7cIWE4Xw&s=0"
          },
          {
              "name": "Coffee",
              "extensions": [
                  "Plant"
              ],
              "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfcHz9Zw7k1LRhNp4pwpZJgImGrgUm4myrYLxi1Dt8t7OHDO0NDTZJMg&s=0"
          }
      ],
      "list": {
          "total_fat": [
              "0 g",
              "0%"
          ],
          "saturated_fat": [
              "0 g",
              "0%"
          ],
          "trans_fat_regulation": [
              "0 g"
          ],
          "cholesterol": [
              "0 mg",
              "0%"
          ],
          "sodium": [
              "5 mg",
              "0%"
          ],
          "potassium": [
              "116 mg",
              "3%"
          ],
          "total_carbohydrate": [
              "0 g",
              "0%"
          ],
          "dietary_fiber": [
              "0 g",
              "0%"
          ],
          "sugar": [
              "0 g"
          ],
          "protein": [
              "0.3 g",
              "0%"
          ],
          "caffeine": [
              "95 mg"
          ],
          "vitamin_c": [
              "0%"
          ],
          "calcium": [
              "0%"
          ],
          "iron": [
              "0%"
          ],
          "vitamin_d": [
              "0%"
          ],
          "vitamin_b6": [
              "0%"
          ],
          "cobalamin": [
              "0%"
          ],
          "magnesium": [
              "1%"
          ]
      }
  },
  "inline_videos": [
      {
          "position": 1,
          "title": "Miguel - Coffee (Official Video)",
          "link": "https://www.youtube.com/watch?v=9Z55sZ2oVY4",
          "thumbnail": "https://i.ytimg.com/vi/9Z55sZ2oVY4/mqdefault.jpg?sqp=-oaymwEECHwQRg&rs=AMzJL3lmDn7L-Zz_UkQc8VRe31tGhwpykg",
          "channel": "MiguelVEVO",
          "duration": "4:55",
          "platform": "YouTube",
          "date": "Jun 16, 2015"
      },
      {
          "position": 2,
          "title": "Beabadoobee - Coffee",
          "link": "https://www.youtube.com/watch?v=C6CeA6vRtW4",
          "thumbnail": "https://i.ytimg.com/vi/C6CeA6vRtW4/mqdefault.jpg?sqp=-oaymwEECHwQRg&rs=AMzJL3lxlj8mR2orEkgAvcZU4MwOpbl3YQ",
          "channel": "Beabadoobee",
          "duration": "1:58",
          "platform": "YouTube",
          "date": "Mar 26, 2020"
      },
      {
          "position": 3,
          "title": "Top-rated coffee makers to step up your morning cup of joe",
          "link": "https://www.today.com/video/top-rated-coffee-makers-to-step-up-your-morning-cup-of-joe-138552389986",
          "thumbnail": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAwRSQk2XtQQ6jRwB7JKCSka7RkJ_Cyb0jqIpLctbHKS0&s",
          "channel": "TODAY",
          "duration": "4:41",
          "platform": "Today Show",
          "date": "16 hours ago"
      }
  ],
  "related_questions": [
      {
          "question": "Is coffee good for your health?",
          "snippet": "“For most people, moderate coffee consumption can be incorporated into a healthy diet.” Hu said that moderate coffee intake—about 2–5 cups a day—is linked to a lower likelihood of type 2 diabetes, heart disease, liver and endometrial cancers, Parkinson's disease, and depression.",
          "title": "Is coffee good or bad for your health? | News",
          "link": "https://www.hsph.harvard.edu/news/hsph-in-the-news/is-coffee-good-or-bad-for-your-health/",
          "displayed_link": "https://www.hsph.harvard.edu › news › hsph-in-the-news"
      },
      {
          "question": "What coffee do to your body?",
          "snippet": "Coffee containing caffeine can cause insomnia, nervousness and restlessness, stomach upset, nausea and vomiting, increased heart and breathing rate, and other side effects. Caffeinated coffee is POSSIBLY UNSAFE when taken by mouth for a long time or in high doses (more than 4 cups per day).",
          "title": "COFFEE: Overview, Uses, Side Effects, Precautions, Interactions, Dosing ...",
          "link": "https://www.webmd.com/vitamins/ai/ingredientmono-980/coffee",
          "displayed_link": "https://www.webmd.com › vitamins › ingredientmono-980"
      },
      {
          "question": "Is coffee made from poop?",
          "snippet": "This is bad news for civets. It's the world's most expensive coffee, and it's made from poop. Or rather, it's made from coffee beans that are partially digested and then pooped out by the civet, a catlike creature. A cup of kopi luwak, as it's known, can sell for as much as $80 in the United States.Apr 29, 2016",
          "title": "The Disturbing Secret Behind the World's Most Expensive Coffee",
          "link": "https://www.nationalgeographic.com/animals/article/160429-kopi-luwak-captive-civet-coffee-Indonesia",
          "displayed_link": "https://www.nationalgeographic.com › animals › article"
      },
      {
          "question": "Is coffee good for your heart?",
          "snippet": "Drinking coffee—particularly two to three cups a day—is not only associated with a lower risk of heart disease and dangerous heart rhythms but also with living longer, according to studies being presented at the American College of Cardiology's 71st Annual Scientific Session.Mar 24, 2022",
          "title": "Good News for Coffee Lovers: Daily Coffee May Benefit the Heart",
          "link": "https://www.acc.org/About-ACC/Press-Releases/2022/03/23/17/55/Good-News-for-Coffee-Lovers-Daily-Coffee-May-Benefit-the-Heart",
          "displayed_link": "https://www.acc.org › Press-Releases › 2022/03/23 › Goo..."
      }
  ],
  "organic_results": [
      {
          "position": 1,
          "title": "Coffee - Wikipedia",
          "link": "https://en.wikipedia.org/wiki/Coffee",
          "displayed_link": "https://en.wikipedia.org › wiki › Coffee",
          "thumbnail": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/b7cc67a2b78dbb467fd73da3a5c83de33f1075c739f8422a9f36bd05bdd0ca9f.jpeg",
          "snippet": "Coffee is a brewed drink prepared from roasted coffee beans, the seeds of berries from certain flowering plants in the Coffea genus. From the coffee fruit, ...",
          "snippet_highlighted_words": [
              "Coffee",
              "coffee",
              "coffee"
          ],
          "sitelinks": {
              "inline": [
                  {
                      "title": "History",
                      "link": "https://en.wikipedia.org/wiki/History_of_coffee"
                  },
                  {
                      "title": "Coffee bean",
                      "link": "https://en.wikipedia.org/wiki/Coffee_bean"
                  },
                  {
                      "title": "Coffee production",
                      "link": "https://en.wikipedia.org/wiki/Coffee_production"
                  },
                  {
                      "title": "Coffee preparation",
                      "link": "https://en.wikipedia.org/wiki/Coffee_preparation"
                  }
              ]
          },
          "rich_snippet": {
              "bottom": {
                  "extensions": [
                      "Region of origin: Horn of Africa and ‎South Ara...‎",
                      "Color: Black, dark brown, light brown, beige",
                      "Introduced: 15th century"
                  ],
                  "detected_extensions": {
                      "introduced_th_century": 15
                  }
              }
          }
      },
      {
          "position": 2,
          "title": "Peet's Coffee: The Original Craft Coffee",
          "link": "https://www.peets.com/",
          "displayed_link": "https://www.peets.com",
          "thumbnail": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/b7cc67a2b78dbb467fd73da3a5c83de3113fb283f0bb144163744ad948b9e5b9.jpeg",
          "snippet": "Since 1966, Peet's Coffee has offered superior coffees and teas by sourcing the best quality coffee beans and tea leaves in the world and adhering to strict ...",
          "snippet_highlighted_words": [
              "Coffee",
              "coffees",
              "coffee"
          ]
      },
      {
          "position": 3,
          "title": "The Coffee Bean & Tea Leaf | CBTL",
          "link": "https://www.coffeebean.com/",
          "displayed_link": "https://www.coffeebean.com",
          "snippet": "Born and brewed in Southern California since 1963, The Coffee Bean & Tea Leaf® is passionate about connecting loyal customers with carefully handcrafted ...",
          "snippet_highlighted_words": [
              "Coffee"
          ]
      },
      {
          "position": 4,
          "title": "Starbucks Coffee Company",
          "link": "https://www.starbucks.com/",
          "displayed_link": "https://www.starbucks.com",
          "thumbnail": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/b7cc67a2b78dbb467fd73da3a5c83de3a04efcc42779ec49d011046a07415167.jpeg",
          "snippet": "More than just great coffee. Explore the menu, sign up for Starbucks® Rewards, manage your gift card and more.",
          "snippet_highlighted_words": [
              "coffee"
          ]
      },
      {
          "position": 5,
          "title": "9 Health Benefits of Coffee, Based on Science - Healthline",
          "link": "https://www.healthline.com/nutrition/top-evidence-based-health-benefits-of-coffee",
          "displayed_link": "https://www.healthline.com › nutrition › top-evidence-b...",
          "thumbnail": "https://serpapi.com/searches/6267890695bf9228b14f8f79/images/b7cc67a2b78dbb467fd73da3a5c83de32a6627e6ab182a79426740d78c9fdb00.jpeg",
          "snippet": "Coffee is a major source of antioxidants in the diet. It has many health benefits, such as improved brain function and a lower risk of several diseases.",
          "snippet_highlighted_words": [
              "Coffee"
          ]
      },
      {
          "position": 6,
          "title": "The History of Coffee",
          "link": "https://www.ncausa.org/about-coffee/history-of-coffee",
          "displayed_link": "https://www.ncausa.org › ... › History of Coffee",
          "snippet": "The story goes that that Kaldi discovered coffee after he noticed that after eating the berries from a certain tree, his goats became so energetic that they did ...",
          "snippet_highlighted_words": [
              "coffee"
          ],
          "related_results": [
              {
                  "position": 1,
                  "title": "What is Coffee?",
                  "link": "https://www.ncausa.org/About-Coffee/What-is-Coffee",
                  "displayed_link": "https://www.ncausa.org › About Coffee",
                  "snippet": "cof·fee /ˈkôfē,ˈkäfē/ noun The berries harvested from species of Coffea plants. Everyone recognizes a roasted coffee bean, but you might not recognize an actual ...",
                  "snippet_highlighted_words": [
                      "coffee"
                  ]
              }
          ]
      },
      {
          "position": 7,
          "title": "coffee | Origin, Types, Uses, History, & Facts ...",
          "link": "https://www.britannica.com/topic/coffee",
          "displayed_link": "https://www.britannica.com › ... › Food",
          "thumbnail": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTteEQWon838YfFccHP0VOLqz6jUG81vb0VOkP2nyuJhprTsgx0wq96&usqp=CAE&s",
          "date": "Mar 4, 2022",
          "snippet": "coffee, beverage brewed from the roasted and ground seeds of the tropical evergreen coffee plants of African origin. Coffee is one of the ...",
          "snippet_highlighted_words": [
              "coffee",
              "coffee",
              "Coffee"
          ]
      }
  ],
  "related_searches": [
      {
          "query": "coffee near me",
          "link": "https://www.google.com/search?q=Coffee+near+me&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q1QJ6BAhQEAE"
      },
      {
          "query": "coffee brands",
          "link": "https://www.google.com/search?q=Coffee+brands&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q1QJ6BAhIEAE"
      },
      {
          "query": "coffee types",
          "link": "https://www.google.com/search?q=Coffee+types&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q1QJ6BAhJEAE"
      },
      {
          "query": "coffee recipe",
          "link": "https://www.google.com/search?q=Coffee+recipe&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q1QJ6BAhMEAE"
      },
      {
          "query": "coffee online",
          "link": "https://www.google.com/search?q=Coffee+online&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q1QJ6BAhNEAE"
      },
      {
          "query": "coffee benefits",
          "link": "https://www.google.com/search?q=Coffee+benefits&sa=X&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q1QJ6BAhPEAE"
      }
  ],
  "pagination": {
      "current": 1,
      "next": "https://www.google.com/search?q=Coffee&ei=CIlnYs6UIoGgqtsPws6D-A0&start=10&sa=N&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q8NMDegQIAxBK",
      "other_pages": {
          "2": "https://www.google.com/search?q=Coffee&ei=CIlnYs6UIoGgqtsPws6D-A0&start=10&sa=N&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q8tMDegQIAxA4",
          "3": "https://www.google.com/search?q=Coffee&ei=CIlnYs6UIoGgqtsPws6D-A0&start=20&sa=N&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q8tMDegQIAxA6",
          "4": "https://www.google.com/search?q=Coffee&ei=CIlnYs6UIoGgqtsPws6D-A0&start=30&sa=N&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q8tMDegQIAxA8",
          "5": "https://www.google.com/search?q=Coffee&ei=CIlnYs6UIoGgqtsPws6D-A0&start=40&sa=N&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q8tMDegQIAxA-",
          "6": "https://www.google.com/search?q=Coffee&ei=CIlnYs6UIoGgqtsPws6D-A0&start=50&sa=N&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q8tMDegQIAxBA",
          "7": "https://www.google.com/search?q=Coffee&ei=CIlnYs6UIoGgqtsPws6D-A0&start=60&sa=N&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q8tMDegQIAxBC",
          "8": "https://www.google.com/search?q=Coffee&ei=CIlnYs6UIoGgqtsPws6D-A0&start=70&sa=N&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q8tMDegQIAxBE",
          "9": "https://www.google.com/search?q=Coffee&ei=CIlnYs6UIoGgqtsPws6D-A0&start=80&sa=N&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q8tMDegQIAxBG",
          "10": "https://www.google.com/search?q=Coffee&ei=CIlnYs6UIoGgqtsPws6D-A0&start=90&sa=N&ved=2ahUKEwjOuNuVhbH3AhUBkGoFHULnAN8Q8tMDegQIAxBI"
      }
  },
  "serpapi_pagination": {
      "current": 1,
      "next_link": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Coffee&start=10",
      "next": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Coffee&start=10",
      "other_pages": {
          "2": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Coffee&start=10",
          "3": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Coffee&start=20",
          "4": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Coffee&start=30",
          "5": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Coffee&start=40",
          "6": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Coffee&start=50",
          "7": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Coffee&start=60",
          "8": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Coffee&start=70",
          "9": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Coffee&start=80",
          "10": "https://serpapi.com/search.json?device=desktop&engine=google&google_domain=google.com&q=Coffee&start=90"
      }
  }
}